export default function seoWidget() {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  function modifyTitle(data) {
    const { Title: text } = data.items[0];
    const h1 = `<h1 class="card-widget-title" aria-label="${text}">${text}</h1>`;
    $widgetHTML.find('.card-widget-title').replaceWith(h1);
  }

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      const button = $widgetHTML.find('.moreButton');
      if (hasData) {
        modifyTitle(data);
        button.addClass('button');
      } else {
        $widgetHTML.remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'Learn More',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}
